module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.common.login) ? _c('div', {
    staticClass: "content-left menuSide"
  }, [_c('div', {
    class: [_vm.open ? 'open' : '', 'header-logo']
  }, [_c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "margin-top": "5px"
    },
    attrs: {
      "src": require("../../assets/mondoconnex-menu-logo.svg")
    }
  })])]), _vm._v(" "), _c('mu-drawer', {
    staticStyle: {
      "padding-top": "65px"
    },
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked,
      "overlay": _vm.docked
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "mu-list-wrap",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding-bottom": "355px"
    },
    attrs: {
      "toggle-nested": ""
    },
    on: {
      "itemClick": function($event) {
        _vm.docked ? '' : _vm.close()
      }
    }
  }, [_c('mu-list-item', {
    staticClass: "menu-company-name"
  }, [_c('mu-list-item-title', [_vm._v(_vm._s(_vm.$store.state.common.companyName))])], 1), _vm._v(" "), _c('mu-list-item', {
    staticClass: "menu-sub-title"
  }, [_c('mu-list-item-title', [_vm._v("Venue")])], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "button": "",
      "avatar": "",
      "to": _vm.$settings.basicURL + '/venue/list',
      "id": "side-nav-your-campaigns"
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "business"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Your Venues")])], 1), _vm._v(" "), (_vm.$store.state.common.admin) ? _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/venue/leads',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "toc"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Contact Tracing Database")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.admin) ? _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/venue/marketing-list',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "contacts"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Your Marketing List")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.rootAdmin && (_vm.$store.state.common.enablePurchase || _vm.$store.state.common.enableMarketing)) ? _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/invoices',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "payment"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Invoices")])], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    staticClass: "menu-sub-title"
  }, [_c('mu-list-item-title', [_vm._v("Account")])], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/profile',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "account_box"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Profile")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu-bottom-wrap"
  }, [_c('div', {
    staticClass: "list-line"
  }), _vm._v(" "), _c('mu-list', [_c('mu-list-item', {
    staticClass: "no-icon-item sub-item small-text",
    attrs: {
      "button": "",
      "href": 'https://www.mondoconnex.com/contact',
      "target": "_blank"
    },
    on: {
      "click": _vm.mobileClose
    }
  }, [_c('mu-list-item-title', [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('mu-list-item', {
    staticClass: "mobile-show",
    staticStyle: {
      "padding": "10px 0",
      "border-top": "1px solid #3c3c3c"
    },
    attrs: {
      "button": "",
      "avatar": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "input"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Log out")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu-bottom-text-content"
  }, [_vm._v("\n              MondoConneX © 2020"), _c('br'), _vm._v("v2.0\n            ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.common.login) ? _c('div', {
    staticClass: "content-left menuSide"
  }, [_c('mu-drawer', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked,
      "overlay": _vm.docked
    },
    on: {
      "close": _vm.close
    }
  }, [_c('mu-appbar', {
    staticClass: "mobile-menu-appbar",
    attrs: {
      "title": ""
    }
  }, [_c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "margin-top": "27px"
    },
    attrs: {
      "src": require("../../assets/MondoConneX_Logo.png")
    }
  })])]), _vm._v(" "), _c('mu-list', {
    on: {
      "itemClick": function($event) {
        _vm.docked ? '' : _vm.close()
      }
    }
  }, [_c('mu-list-item', {
    attrs: {
      "button": "",
      "avatar": "",
      "to": _vm.$settings.basicURL + '/registration'
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "assignment"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Registration")])], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": _vm.$settings.basicURL + '/login',
      "button": "",
      "avatar": ""
    }
  }, [_c('mu-list-item-action', [_c('mu-icon', {
    attrs: {
      "value": "assignment_ind"
    }
  })], 1), _vm._v(" "), _c('mu-list-item-title', [_vm._v("Login")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu-bottom-wrap"
  }, [_c('div', {
    staticClass: "side-menu-bottom-text-content"
  }, [_vm._v("\n            MondoConneX © 2020"), _c('br'), _vm._v("v1.0\n          ")])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ff056f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/asider.vue
// module id = 205
// module chunks = 14